import { Component, OnInit, Input } from '@angular/core';
import { InvestorDataService } from '../../../core/investor-data.service';
import { Investor } from '../../shared/models/investor';
import { ActivatedRoute } from '@angular/router';
import { DoughnutChartItem } from '../../shared/components/doughnut-chart/dought-item';
import * as html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-insurance-report',
  templateUrl: './insurance-report.component.html',
  styleUrls: ['./insurance-report.component.css']
})
export class InsuranceReportComponent implements OnInit {
  uid: string;
  @Input() 
  investor: Investor;
  insuranceCharts: {
    [key: string] : {
      [key: string]: Array<DoughnutChartItem>;
    }
  }
  // Array<Array<Array<DoughnutChartItem>>>;
  constructor(
    private _Activatedroute: ActivatedRoute,
    private manageInvestorService: InvestorDataService,
  ) {
    this.insuranceCharts = {};
  }

  getUpdatedAtDate(investor: Investor){
    return new Date(investor.updatedAt.toString()).toDateString();
  }
  getRiskTitle(risk: string){
    switch(risk){
      case('conservative'):
      case('moderate'):
      case('aggressive'):
      return risk;
      case('moderate_plus'):
      return 'moderate plus';
      case('higly_aggressive'):
      return 'highly aggressive';
      default: 
      return 'unknown';
    }
  }
  makePDF2() {
    var data = document.getElementById('fin-report-pdf');
    var opt = {
      margin: [10, 0],
      filename: (this.investor ? this.investor.name? this.investor.name + "'s " : "Investor's " : "Investor's " ) + 'Insurance Report.pdf',
      image: { type: 'png', quality: 1 },
      html2canvas: { scale: 1 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    // New Promise-based usage:
    html2pdf()
      .from(data)
      .set(opt)
      .save();
  }
  ngOnInit() {
    this.uid = this._Activatedroute.snapshot.params['uid'];
    if (!this.uid) {
      
      return;
    }
    this.manageInvestorService
      .getInvestorByKey(this.uid)
      .get()
      .then((value) => {
        this.investor = new Investor(value.data());
        this.initChartItems();
      });
  }
  getDateInFormat(date: string){
    const DOB = new Date(date);
    return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"][DOB.getMonth()] + " " + DOB.getDate() + " " + DOB.getFullYear();
  }
  getAge(date: string): number {
    const DOB = new Date(date);
    if (DOB) {
      var ageDifMs = Date.now() - DOB.getTime();
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    } else {
      return null;
    }
  }
  initChartItems() {
    if(this.investor){
      this.investor.insurances['life_insurance'].forEach((element)=>{
        this.insuranceCharts['life_insurance'] = {
          ...this.insuranceCharts['life_insurance'],
          [element.type]: [
            new DoughnutChartItem('Existing',element.existing_value ,'green', 0),
            new DoughnutChartItem('Need to buy',element.needed_value ,'red', 0)
          ]
        }
      })
      this.investor.insurances['health_insurance'].forEach((element)=>{
        this.insuranceCharts['health_insurance'] = {
          ...this.insuranceCharts['health_insurance'],
          [element.type]: [
            new DoughnutChartItem('Existing',element.existing_value ,'green', 0),
            new DoughnutChartItem('Need to buy',element.needed_value ,'red', 0)
          ]
        }
      })
      this.investor.insurances['personal_accident_insurance'].forEach((element)=>{
        this.insuranceCharts['personal_accident_insurance'] = {
          ...this.insuranceCharts['personal_accident_insurance'],
          [element.type]: [
            new DoughnutChartItem('Existing',element.existing_value ,'green', 0),
            new DoughnutChartItem('Need to buy',element.needed_value ,'red', 0)
          ]
        }
      })
      
      console.log(this.insuranceCharts);
      
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/insurance-report/insurance-report.component.ts